import JsonManager from './JsonManager';
import ImageManager from './ImageManager';

class SectionManager {
  constructor(id) {
    this.id = id;
    this.projectID = '';
    this.section = JsonManager.getSection(id);
    if (this.section) {
      this.projects = this.section.projects;
    }
  }

  getProjects() {
    if (this.projects) {
      return this.projects.map(projectID => ({ ...this.getProject(projectID) }));
    }
    return null;
  }

  // Used to override in SearchManager
  setProjectID(projectID) {
    this.projectID = projectID;
  }

  getProject(projectID) {
    this.setProjectID(projectID);
    const id = this.projectID;
    const Project = JsonManager.getProject(id);
    const ImageMan = new ImageManager(id);

    if (Project) {
      return {
        id,
        title: Project.title,
        subtitle: Project.subtitle,
        image: ImageMan.getProjectTitleImage(),
        tiny: ImageMan.getProjectTinyTitleImage(),
      };
    }
    return null;
  }

  getTitle() {
    return this.section.title;
  }

  getSubtitle() {
    return this.section.subtitle;
  }

  getDescription() {
    return this.section.description;
  }
}

export default SectionManager;



// WEBPACK FOOTER //
// ./src/managers/SectionManager.js